"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var DateTime_1 = __importDefault(require("./DateTime/DateTime"));
var DateRange_1 = __importDefault(require("./DateRange/DateRange"));
var translations_1 = __importDefault(require("./translations"));
var localization_1 = require("@scuf/localization");
/**
 * The DatePicker component allows a user to select dates in multiple formats.
 * - Date
 * - Date Range
 * - Date and Time *(New in v52.6)*
 */
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.propGroup = function (group) {
            var _a = _this.props, rangeValue = _a.rangeValue, onRangeSelect = _a.onRangeSelect, type = _a.type, value = _a.value, base = __rest(_a, ["rangeValue", "onRangeSelect", "type", "value"]);
            switch (group) {
                case 'date':
                    return __assign({ value: value }, base);
                case 'datetime':
                    return __assign({ value: value, time: true }, base);
                case 'daterange':
                    return __assign({ rangeValue: rangeValue, onRangeSelect: onRangeSelect }, base);
                default:
                    return {};
            }
        };
        return _this;
    }
    DatePicker.prototype.render = function () {
        var type = this.props.type;
        var props = this.propGroup(type);
        return (React.createElement(localization_1.LocalizationProvider, { translations: translations_1.default },
            (type === 'date' || type === 'datetime') && React.createElement(DateTime_1.default, __assign({}, props)),
            type === 'daterange' && React.createElement(DateRange_1.default, __assign({}, props))));
    };
    DatePicker.defaultProps = {
        type: 'date',
        showYearSelector: false
    };
    return DatePicker;
}(React.Component));
exports.default = DatePicker;
